import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css'
import { curriculumData } from './data/curriculum';

import { ThemeProvider } from './context/ThemeContext';

// Enhance SEO with structured data from curriculum
const injectStructuredData = () => {
    const skills = new Set();
    const awards = [];
    const alumniOf = [];
    const worksFor = [];

    curriculumData.forEach(item => {
        // Collect Skills
        if (item.tags) {
            item.tags.forEach(tag => skills.add(tag));
        }

        // Collect Categories
        if (item.type === 'Awards') {
            awards.push(item.title);
        } else if (item.type === 'Education') {
            alumniOf.push({
                "@type": "EducationalOrganization",
                "name": item.title,
                "description": item.subtitle
            });
        } else if (item.type === 'Experience') {
            worksFor.push({
                "@type": "Organization",
                "name": item.title,
                "description": item.subtitle
            });
        }
    });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Salvatore Lo Sardo",
        "url": "https://www.salvatore.losardo.eu/",
        "jobTitle": "MSc Student in Artificial Intelligence",
        "description": "MSc Student in Artificial Intelligence at UvA. Passionate about Machine Learning, Deep Learning, Agentic AI, RAG pipelines, and Robotics.",
        "sameAs": [
            "https://www.linkedin.com/in/salvatorels/",
            "https://github.com/SalvatoreLS",
            "https://scholar.google.com/citations?user=TzWJ0VQAAAAJ&hl=en"
        ],
        "knowsAbout": Array.from(skills),
        "award": awards,
        "alumniOf": alumniOf,
        "worksFor": worksFor
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);
};

injectStructuredData();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <HelmetProvider>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </HelmetProvider>
);